import React from "react";
import { Search, X } from "lucide-react";
import { CATEGORY_LABELS, MONTH_NAMES } from "../../lib/format";

export const Filters = ({
  q, setQ,
  category, setCategory,
  status, setStatus,
  month, setMonth,
  categories = [],
  statuses = [],
  onClear,
  resultCount = 0,
}) => {
  return (
    <div
      data-testid="filters"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        alignItems: "center",
        padding: "1.1rem",
        border: "1px solid hsl(var(--line))",
        background: "hsl(var(--bg-elev))",
      }}
    >
      <label style={{ position: "relative", flex: "2 1 240px", minWidth: 220 }}>
        <span className="sr-only">Search the archive</span>
        <Search size={15} aria-hidden style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "hsl(var(--muted))" }} />
        <input
          type="search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by name, person, or theme…"
          data-testid="filters-search"
          style={{
            width: "100%",
            padding: "0.65rem 0.85rem 0.65rem 2.1rem",
            border: "1px solid hsl(var(--line))",
            background: "hsl(var(--bg))",
            color: "hsl(var(--ink))",
            fontSize: "0.92rem",
            fontFamily: "var(--font-body)",
            borderRadius: 2,
          }}
        />
      </label>

      <select
        value={category}
        onChange={(e) => setCategory(e.target.value)}
        aria-label="Filter by category"
        data-testid="filters-category"
        style={selectStyle}
      >
        <option value="">All categories</option>
        {categories.map((c) => (
          <option key={c.category} value={c.category}>
            {CATEGORY_LABELS[c.category] || c.category} ({c.count})
          </option>
        ))}
      </select>

      <select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
        aria-label="Filter by recognition status"
        data-testid="filters-status"
        style={selectStyle}
      >
        <option value="">All recognition</option>
        {statuses.map((s) => (
          <option key={s.status} value={s.status}>{s.status} ({s.count})</option>
        ))}
      </select>

      <select
        value={month}
        onChange={(e) => setMonth(e.target.value)}
        aria-label="Filter by month"
        data-testid="filters-month"
        style={selectStyle}
      >
        <option value="">All months</option>
        {MONTH_NAMES.slice(1).map((m, i) => (
          <option key={m} value={i + 1}>{m}</option>
        ))}
      </select>

      <div style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center", gap: 12 }}>
        <span style={{ fontSize: "0.78rem", letterSpacing: "0.12em", textTransform: "uppercase", color: "hsl(var(--muted))" }}>
          {resultCount} entries
        </span>
        {(q || category || status || month) && (
          <button
            type="button"
            onClick={onClear}
            data-testid="filters-clear"
            style={{
              display: "inline-flex", alignItems: "center", gap: 4,
              fontSize: "0.78rem", letterSpacing: "0.06em", textTransform: "uppercase",
              padding: "0.4rem 0.7rem",
              background: "transparent",
              border: "1px solid hsl(var(--line))",
              color: "hsl(var(--ink-soft))",
              cursor: "pointer",
              borderRadius: 2,
            }}
          >
            <X size={12} aria-hidden /> Clear
          </button>
        )}
      </div>
    </div>
  );
};

const selectStyle = {
  flex: "1 1 160px",
  minWidth: 150,
  padding: "0.65rem 0.85rem",
  border: "1px solid hsl(var(--line))",
  background: "hsl(var(--bg))",
  color: "hsl(var(--ink))",
  fontSize: "0.9rem",
  fontFamily: "var(--font-body)",
  borderRadius: 2,
  cursor: "pointer",
};
